"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { CheckboxProvider } from "./use-checkbox-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/checkbox/checkbox-root-provider.tsx
var splitRootProviderProps = createSplitProps();
var CheckboxRootProvider = forwardRef((props, ref) => {
	const [{ value: checkbox }, localProps] = splitRootProviderProps(props, ["value"]);
	const mergedProps = mergeProps(checkbox.getRootProps(), localProps);
	return /* @__PURE__ */ jsx(CheckboxProvider, {
		value: checkbox,
		children: /* @__PURE__ */ jsx(ark.label, {
			...mergedProps,
			ref
		})
	});
});
CheckboxRootProvider.displayName = "CheckboxRootProvider";
//#endregion
export { CheckboxRootProvider };
